import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

function CardVideo() {
  const [videos, setVideos] = useState([]);

  const defaultVideos = [
    {
      url: "https://youtu.be/4Okjdo481Yk?si=peZ7Ll-j9kl-Fwul",
      createdAt: "2024-08-21T00:00:00Z",
      title: "Sambutan Kepla Sekolah Islam Cendekia Harapan",
    },
    {
      url: "https://youtu.be/Qs_A8qx-RaU?si=Q3-tkfozoqbxpWel",
      createdAt: "2024-08-21T00:00:00Z",
      title: "Kemah Hari Pramuka Sekolah Islam Cendekia Harapan",
    },
  ];

   useEffect(() => {
    const fetchVideoData = async () => {
      try {
        const response = await axios.get(`/api_w/galeries?type=video`, {
          headers: {
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });

        if (response.data.data && response.data.data.length > 0) {
          setVideos(response.data.data);
        } else {
          setVideos(defaultVideos);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || error.message);
        setVideos(defaultVideos);
      }
    };

    fetchVideoData();
  }, []);

  const formatDate = (dateString) => {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return new Date(dateString).toLocaleDateString("id-ID", options);
  };

  // 🔹 DETEKSI PLATFORM
  const getEmbedUrl = (videoUrl) => {
    // YouTube (termasuk shorts)
    const youtubeMatch = videoUrl.match(
      /(?:youtube\.com\/(?:shorts\/|watch\?v=)|youtu\.be\/)([^"&?\/\s]{11})/
    );
    if (youtubeMatch) {
      return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
    }

    // Google Drive
    const gdriveMatch = videoUrl.match(/drive\.google\.com\/file\/d\/([^\/]+)\//);
    if (gdriveMatch) {
      return `https://drive.google.com/file/d/${gdriveMatch[1]}/preview`;
    }

    // TikTok (gunakan format embed resmi)
    const tiktokMatch = videoUrl.match(/tiktok\.com\/@[^\/]+\/video\/(\d+)/);
    if (tiktokMatch) {
      return `https://www.tiktok.com/embed/${tiktokMatch[1]}`;
    }

    // Facebook (gunakan plugin resmi)
    if (videoUrl.includes("facebook.com")) {
      return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
        videoUrl
      )}&show_text=false&width=350`;
    }

    // Instagram
    if (videoUrl.includes("instagram.com")) {
      return `${videoUrl}embed`;
    }

    // Default: tampilkan link langsung
    return videoUrl;
  };

  const renderMedia = (videoUrl) => {
    const embedUrl = getEmbedUrl(videoUrl);

    return (
      <iframe
        className="h-[200px] w-[100%] rounded-md md:w-[350px]"
        src={embedUrl}
        title="Video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      ></iframe>
    );
  };

  return (
    <div className="mb-8">
      <h3 className="headers text-xl mt-[25px]">
        <span className="border-b-2 border-blue-600 font-bold hover:cursor-pointer hover:text-blue-700">
          Video
        </span>
      </h3>
      <div className="mt-5">
        {videos.map((video) => (
          <div
            key={video.id}
            className="mt-6 flex flex-col md:flex-row shadow-md"
          >
            <div className="md:mr-4">{renderMedia(video.url)}</div>
            <div className="flex flex-col">
              <h4 className="mt-2 font-bold text-xl hover:text-blue-700">{video.title}</h4>
              <p className="text-gray-500 mb-4 mt-2">
                {formatDate(video.createdAt)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CardVideo;
